import React from 'react'

import { YouthFootballGrantWinners2018 } from '../../../config/images'

const YFGW2018Array = [
	{ path: '44379405_2199904253418087_7542876996083122176_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44490720_2199897463418766_4019093935895871488_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44606628_2199885396753306_3235585811118292992_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44493038_2199888756752970_8785936257776615424_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44474654_2199896123418900_4197121502841143296_o.jpg', w: 1000, h: 668 },
	{ path: '44337402_2199893306752515_9218476766274781184_o.jpg', w: 1000, h: 668 },
	{ path: '44535067_2199893046752541_3029340897448820736_o.jpg', w: 1000, h: 668 },
	{ path: '44455661_2199900926751753_1743479971663314944_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44650397_2199884670086712_6503369239708041216_o.jpg', w: 1000, h: 668 },
	{ path: '44493371_2199958196746026_2230715497106636800_o.jpg', w: 1000, h: 668 },
	{ path: '44506956_2199902400084939_593918901008465920_o.jpg', w: 1000, h: 668 },
	{ path: '44566978_2199903556751490_1109054710100262912_o.jpg', w: 1000, h: 668 },
	{ path: '44621768_2199886953419817_6506949743489318912_o.jpg', w: 1000, h: 668 },
	{ path: '44480962_2199904786751367_2313467551121670144_o.jpg', w: 1000, h: 668 },
	{ path: '44506953_2199889563419556_8459007874100625408_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44464905_2199884163420096_8596938803191480320_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44514346_2199902740084905_29634552787894272_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44563141_2199900626751783_6290134687671123968_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44606628_2199885396753306_3235585811118292992_o.jpg', w: 1000, h: 668 },
	{ path: '44617884_2199888163419696_3822636200426995712_o.jpg', w: 1000, h: 668 },
	{ path: '44452933_2199896326752213_2172409533652008960_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44639213_2199897783418734_7987866587547828224_o.jpg', w: 1000, h: 668 },
	{ path: '44532953_2199901696751676_829079656228454400_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44474654_2199896123418900_4197121502841143296_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44490720_2199897463418766_4019093935895871488_o.jpg', w: 1000, h: 668 },
	{ path: '44684538_2199901423418370_472742398821138432_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44475022_2199895523418960_6484300886288891904_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44452957_2199888493419663_4681893482288119808_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44452589_2199882730086906_6763359222341042176_o.jpg', w: 1000, h: 668 },
	{ path: '44650397_2199884670086712_6503369239708041216_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44464905_2199884163420096_8596938803191480320_o.jpg', w: 1000, h: 668 },
	{ path: '44458569_2199892153419297_623668515970220032_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44497884_2199896870085492_8563858926422982656_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44617884_2199888163419696_3822636200426995712_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44621768_2199886953419817_6506949743489318912_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44487737_2199892510085928_2061614976736428032_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44598594_2199900196751826_8746159118244380672_o.jpg', w: 1000, h: 668 },
	{ path: '44494127_2199891036752742_3704317865831170048_o.jpg', w: 1000, h: 668 },
	{ path: '44561816_2199904483418064_1555929946826735616_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44639213_2199897783418734_7987866587547828224_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44497884_2199896870085492_8563858926422982656_o.jpg', w: 1000, h: 668 },
	{ path: '44506953_2199889563419556_8459007874100625408_o.jpg', w: 1000, h: 668 },
	{ path: '44598594_2199900196751826_8746159118244380672_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44550234_2199894000085779_1264654370142683136_o.jpg', w: 1000, h: 668 },
	{ path: '44587792_2199902043418308_7078041833917382656_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44516085_2199892793419233_4464046547692158976_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44566978_2199903556751490_1109054710100262912_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44493038_2199888756752970_8785936257776615424_o.jpg', w: 1000, h: 668 },
	{ path: '44452589_2199882730086906_6763359222341042176_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44475022_2199895523418960_6484300886288891904_o.jpg', w: 1000, h: 668 },
	{ path: '44337402_2199893306752515_9218476766274781184_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44506956_2199902400084939_593918901008465920_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44493360_2199896583418854_7071552228527439872_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44635449_2199900406751805_9176731874590982144_o-thumb.jpg', w: 668, h: 1000 },
	{ path: '44516085_2199892793419233_4464046547692158976_o.jpg', w: 1000, h: 668 },
	{ path: '44532953_2199901696751676_829079656228454400_o.jpg', w: 1000, h: 668 },
	{ path: '44546785_2199899953418517_590116819864387584_o.jpg', w: 1000, h: 668 },
	{ path: '44587792_2199902043418308_7078041833917382656_o.jpg', w: 1000, h: 668 },
	{ path: '44561816_2199904483418064_1555929946826735616_o.jpg', w: 1000, h: 668 },
	{ path: '44379405_2199904253418087_7542876996083122176_o.jpg', w: 1000, h: 668 },
	{ path: '44480962_2199904786751367_2313467551121670144_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44461501_2199885740086605_2181521427029557248_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44535067_2199893046752541_3029340897448820736_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44458569_2199892153419297_623668515970220032_o.jpg', w: 1000, h: 668 },
	{ path: '44546830_2199901190085060_8604371226917339136_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44494127_2199891036752742_3704317865831170048_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44452933_2199896326752213_2172409533652008960_o.jpg', w: 1000, h: 668 },
	{ path: '44452957_2199888493419663_4681893482288119808_o.jpg', w: 1000, h: 668 },
	{ path: '44493360_2199896583418854_7071552228527439872_o.jpg', w: 1000, h: 668 },
	{ path: '44684538_2199901423418370_472742398821138432_o.jpg', w: 1000, h: 668 },
	{ path: '44635449_2199900406751805_9176731874590982144_o.jpg', w: 668, h: 1000 },
	{ path: '44550234_2199894000085779_1264654370142683136_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44487737_2199892510085928_2061614976736428032_o.jpg', w: 1000, h: 668 },
	{ path: '44546785_2199899953418517_590116819864387584_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44452920_2199893750085804_940726338950529024_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44455661_2199900926751753_1743479971663314944_o.jpg', w: 1000, h: 668 },
	{ path: '44471994_2199890603419452_5709271112852963328_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44461501_2199885740086605_2181521427029557248_o.jpg', w: 1000, h: 668 },
	{ path: '44514346_2199902740084905_29634552787894272_o.jpg', w: 1000, h: 668 },
	{ path: '44563141_2199900626751783_6290134687671123968_o.jpg', w: 1000, h: 668 },
	{ path: '44452920_2199893750085804_940726338950529024_o.jpg', w: 1000, h: 668 },
	{ path: '44471994_2199890603419452_5709271112852963328_o.jpg', w: 1000, h: 668 },
	{ path: '44493371_2199958196746026_2230715497106636800_o-thumb.jpg', w: 1000, h: 668 },
	{ path: '44546830_2199901190085060_8604371226917339136_o.jpg', w: 1000, h: 668 },
]

const newArray = YFGW2018Array.sort((a, b) => {
	if (a.path < b.path) return -1
	if (a.path > b.path) return 1
	return 0
})

//TODO: To improve this group thumb and full and make a nice full object.

export default () => {
	const componentArray = []
	for (let i = 0; i < newArray.length; i++) {
		componentArray.push(
			<figure
				itemProp="associatedMedia"
				itemScope="itemScope"
				itemType="http://schema.org/ImageObject"
				key={newArray[i].path}
			>
				<a
					href={YouthFootballGrantWinners2018[newArray[i + 1].path]}
					itemProp="contentUrl"
					data-size={`${newArray[i + 1].w}x${newArray[i + 1].h}`}
				>
					<img
						src={YouthFootballGrantWinners2018[newArray[i].path]}
						itemProp="thumbnail"
						alt="description"
					/>
				</a>
				<figcaption itemProp="caption description">{newArray[i + 1].caption}</figcaption>
			</figure>
		)
		i++
	}
	return componentArray
}
